import { Base64 } from "js-base64";

export const ROOT_PAGE = process.env.REACT_APP_ROOT_URL;
export const HOME_PAGE = process.env.PUBLIC_URL;
export const DEV = process.env.REACT_APP_DEV === "true";
export const HTTP_API = process.env.REACT_APP_HTTP_API;
export const HCCD_MS = process.env.REACT_APP_HCCD_MS;
export const TEMPLATE = process.env.REACT_APP_TEMPLATE;
export const APP_NAME = process.env.REACT_APP_APP_NAME;
export const NODE_ENV = process.env.REACT_APP_NODE_ENV;
export const HCCD_N8N = process.env.REACT_APP_HCCD_N8N;


export const UTHORIZATION_COOKIE_APP = Base64.encode(
  HOME_PAGE + APP_NAME + NODE_ENV
);

export const SSO_LOGIN_URL = process.env.REACT_APP_SSO_LOGIN_URL;
export const SSO_TYPE = process.env.REACT_APP_SSO_TYPE;

// VNEID
export const VNEID_LOGIN_URL = process.env.REACT_APP_VNEID_LOGIN_URL;
export const VNEID_LOGOUT_URL = process.env.REACT_APP_VNEID_LOGOUT_URL;

// FORM.IO
export const FORM_IO_URL = process.env.REACT_APP_FORM_IO_URL;

// ATTT
export const CHECK_ATTT = process.env.REACT_APP_CHECK_ATTT === "true";
